import { makeApiRequest } from 'actions/api';
import RequestService from 'services/RequestService';

export const TWO_FACTOR_OPT_IN = 'TWO_FACTOR_OPT_IN';
export const TWO_FACTOR_OPT_IN_REQUEST = 'TWO_FACTOR_OPT_IN_REQUEST';
export const TWO_FACTOR_OPT_IN_RESPONSE = 'TWO_FACTOR_OPT_IN_RESPONSE';
export const TWO_FACTOR_OPT_IN_ERROR = 'TWO_FACTOR_OPT_IN_ERROR';

export const twoFactorOptIn = (params = {}) =>
  makeApiRequest({
    requestType: TWO_FACTOR_OPT_IN,
    method: RequestService.twoFactorOptIn,
    params: { optIns: params },
  });

export const TWO_FACTOR_OPT_OUT = 'TWO_FACTOR_OPT_OUT';
export const TWO_FACTOR_OPT_OUT_REQUEST = 'TWO_FACTOR_OPT_OUT_REQUEST';
export const TWO_FACTOR_OPT_OUT_RESPONSE = 'TWO_FACTOR_OPT_OUT_RESPONSE';
export const TWO_FACTOR_OPT_OUT_ERROR = 'TWO_FACTOR_OPT_OUT_ERROR';

export const twoFactorOptOut = () =>
  makeApiRequest({
    requestType: TWO_FACTOR_OPT_OUT,
    method: RequestService.twoFactorOptOut,
  });

export const GET_TWO_FACTOR_AUTH_SETTINGS = 'GET_TWO_FACTOR_AUTH_SETTINGS';
export const GET_TWO_FACTOR_AUTH_SETTINGS_REQUEST = 'GET_TWO_FACTOR_AUTH_SETTINGS_REQUEST';
export const GET_TWO_FACTOR_AUTH_SETTINGS_RESPONSE = 'GET_TWO_FACTOR_AUTH_SETTINGS_RESPONSE';
export const GET_TWO_FACTOR_AUTH_SETTINGS_ERROR = 'GET_TWO_FACTOR_AUTH_SETTINGS_ERROR';

export const getTwoFactorSettings = () =>
  makeApiRequest({
    requestType: GET_TWO_FACTOR_AUTH_SETTINGS,
    method: RequestService.getTwoFactorSettings,
  });
